import { gql } from '@apollo/client';

import { CampaignLabelMetadata } from './types';

export const USE_CAMPAIGN_LABELS_HOOK_QUERY = gql`
  query CampaignLabelsQuery {
    campaignLabels {
      name
      id
    }
  }
`;

export const DEFAULT_CAMPAIGN_LABELS: CampaignLabelMetadata[] = [];
